// extracted by mini-css-extract-plugin
module.exports = {"customLegend":"Custom_customLegend__1mxEw"};